import*as t from"react";import"react/jsx-runtime";const e=t.createContext(),r=()=>t.useContext(e)??!1;export{r as useRtl};
//# sourceMappingURL=index.js.map
